/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 批量删除用户的评论
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  commentsDelDTO: member.CommentsDelDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/member/comments`,
    data: commentsDelDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
